import styled from "styled-components";

export const TabLeftGrid = styled.div`
  display: grid;
  grid-template-columns: ${props => props.customColumns || "1fr 2fr"};
  justify-content: space-between;
  grid-column-gap: 10%;

  @media (max-width: 800px) {
    grid-column-gap: 10px;
  }
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    justify-content: start;
    grid-row-gap: 15px;
  }
  // @media (max-width: 412px) {
  //   display: flex;
  //   flex-direction: column;
  //   flex-wrap: wrap;
  //   gap: 15px;
  //   & > * {
  //     flex: 1 1 100%; /* each child takes full width */
  //   }
  // }
  @media (max-width: 412px) {
    width: 100%;
  }
`;

export const ClientCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  grid-gap: 12px;
  margin-top: 20px;
`;
export const ClientCard = styled.div`
  position: relative;
  border: 1px solid ${({ theme }) => theme.colors.border.secondaryLight};
  border-radius: ${({ theme }) => theme.borderRadii.button};
`;
export const ClientCardInnerContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ columns }) => columns || `40px auto`};
  grid-column-gap: 12px;
  padding: ${({ padding }) => padding || "15px"};
  align-items: center;
  cursor: pointer;
`;
export const InvoicedCapsule = styled.div`
  padding: 5px 13px;
  border-radius: 14px;
  color: ${({ invoiced, theme }) => (invoiced ? `#82C4BB` : `#EFBD1A`)};
  background-color: ${({ invoiced, theme }) =>
    invoiced ? theme.colors.main.primaryLight : `#FBF3DA`};
  font-size: 12px;
  white-space: nowrap;
  text-align: center;
`;

export const HoveredSection = styled.div`
  position: absolute;
  top: ${({ top }) => top || "-15px"};
  right: ${({ right }) => right || "15px"};
  display: grid;
  grid-template-columns: ${({ columns, unarchive }) =>
    columns ? columns : unarchive ? `1fr 1fr` : `1fr 1fr 1fr`};
  grid-gap: 10px;
`;

export const HoveredSection2 = styled.div`
  position: absolute;
  display: grid;
  grid-template-columns: ${({ columns, unarchive }) =>
    columns ? columns : unarchive ? `1fr 1fr` : `1fr 1fr 1fr`};
  grid-gap: 10px;
`;

export const HoveredSectionClient = styled.div`
  position: absolute;
  /* display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 5px; */
  display: flex;
  justify-content: flex-end;
  gap: 5px;
  right: 0;
  top: 5;
`;

export const RoundHover = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: auto;
  justify-content: center;
  align-content: center;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.border.secondaryLight};
  padding: 2px;
  background-color: white;
  width: 30px;
  height: 30px;
  font-size: 12px;
  cursor: pointer;
  &:hover {
    border-color: ${({ theme }) => theme.colors.border.secondary};
  }
`;

export const ToolTipContainer = styled.div`
  position: absolute;
  top: -33px;
  left: 3px;
  width: 64px;
`;
export const InnerDivTooltip = styled.div`
  position: relative;
`;

export const TooltipText = styled.div`
  position: absolute;
  top: 3px;
  left: 0px;
  font-size: 12px;
  color: rgba(47, 57, 78, 0.7);
  width: 64px;
  text-align: center;
`;

// ---- ADD CLIENT -----

export const AddClientContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px 7%;
  max-width: 760px;
  justify-content: space-between;
  margin-top: 25px;
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

export const AddClientContainerNew = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${({ customGridGap }) => customGridGap || "20px 7%"};
  max-width: 760px;
  justify-content: start;
  align-content: space-between;
  margin-top:${({ marginTop }) => marginTop || "25px"};
  padding-left: ${({ padding }) => padding || "0"};
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

export const ButtonSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  padding: 20px 0;
  grid-row: 4 / 4;
  @media (max-width: 767px) {
    grid-row: auto;
  }
  @media (max-width: 374px) {
    grid-template-columns: 180px;
    grid-gap: 20px;
    justify-content: center;
  }
`;

// ----- CLIENT DETAIL -----

export const SubtitleSection = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 20px;
  justify-content: space-between;
`;

export const ClientNameRow = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 50px;
  justify-content: start;
  margin: 15px 0 30px;
`;

export const CreatedTextgrid = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  grid-column-gap: 15px;
  justify-content: start;
`;

export const GeneralInfoSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  grid-column-gap: 20px;
  margin: 15px 0 30px;
  max-width: 1200px;
`;

export const GeneralInfoSection2 = styled.div`
  display: grid;
  grid-template-columns: ${({ columns }) => columns || "1fr 1fr 1fr 1fr"};
  grid-column-gap: 20px;
  margin: 15px 0 30px;
  max-width: 1200px;
`;

export const GeneralInfoItem = styled.div`
  display: grid;
  grid-template-columns: auto;
  grid-row-gap: 10px;
  justify-content: center;
  align-content: center;
  padding: 15px 20px;
  border-radius: 6px;
  text-align: center;
  background-color: ${props =>
    props.backColor === 1
      ? `#EAF9F7`
      : props.backColor === 2
      ? `#FBF3DA`
      : props.backColor === 3
      ? `#DFE2FF`
      : props.backColor === 4
      ? `#D0F6FF`
      : props.backColor === 5
      ? `#F9D8D6`
      : props.backColor === 6
      ? `#c7f2d0`
      : props.backColor === 7
      ? `#EFF9DA`
      : props.backColor === 8
      ? `#FEF5E8`
      : `#ECF0FC`};
  min-height: ${props => props.minHeight || "100px"};
  width: ${props => props.width || "auto"}; /* Add width */
  margin: ${props => props.margin || "0"}; /* Conditional margin */
`;

export const InvoiceTitle = styled.p`
  margin: 45px 0 10px;
  color: #2f394e;
  font-size: 16px;
  font-weight: 600;
`;

export const InvoiceTableSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1.4fr minmax(100px, 150px) 1fr;
  grid-column-gap: 20px;
  justify-content: space-between;
  padding: 0 30px;
  border-bottom: ${({ heading, theme }) =>
    heading && `1px solid ${theme.colors.border.secondary}`};
  :nth-of-type(odd) {
    background-color: ${({ heading }) => !heading && `#f8f9fc`};
  }
  /* @media (max-width: 1250px) {
    grid-template-columns: 160px 110px 150px 200px 150px 100px 150px;
    grid-column-gap: 10px;
  } */
`;

export const ClientLocationsTableHeaderContainer = styled.div`
  display: grid;
  grid-template-columns:${({ columns }) => columns || "300px 200px  minmax(300px, 400px) 300px"};
  grid-column-gap: 20px;
  justify-content: flex-start;
  padding: ${({ theme }) => theme.table.tableHeaderPadding};
  border-radius: ${({ theme }) => theme.table.tableRowBorderRadius};
  // border-bottom: 1px solid ${({ theme }) => theme.colors.border.secondary};
  background-color: ${({ theme }) => theme.colors.main.tableHeaderBackground};
  /* @media screen and (max-width: 1400px) {
    grid-template-columns: repeat(${props => props.columns || 4}, 1fr);
  } */
`;

export const ClientLocationsTableRowContainer = styled.div`
  display: grid;
  grid-template-columns:${({ columns }) => columns || "300px 200px  minmax(300px, 400px) 200px"};
  grid-column-gap: 20px;
  justify-content: flex-start;

  padding: 10px 0px 10px 12px;
  // :nth-of-type(even) {
  //   background-color: #f8f9fc;
  // }
  border-bottom: 1px solid
    ${({ isLastItem, theme }) =>
      isLastItem ? "transparent" : theme.colors.border.tableBorder};
  /* @media screen and (max-width: 1400px) {
    grid-template-columns: repeat(${props => props.columns || 4}, 1fr);
  } */
`;

export const LocationItem = styled.div`
  background-color: #ffffff;
  padding: 8px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
`;

export const LocationContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;
